module.exports = __webpack_public_path__ + "img/main-logo-orange.bc99f2fe.png";